import environments from './environments.json'

export type EnvironmentName = keyof typeof environments

type EnvironmentsConfig = { [key in EnvironmentName]: Environment }

interface Environment {
  readonly analytics_id?: string
  readonly analytics_uri?: string
  readonly api_domain: string
  readonly auth_domain: string
  readonly mirror_app_id: string
  readonly graphql_api_domain: string
  readonly web_renderer_image_domain: string
  readonly paymentql_api_domain: string
  readonly events_uri: string
  readonly presences_ws_uri: string
  readonly stripe_api_key: string
  readonly health_uri: string
  readonly telemetry_uri: string
}

export default environments as EnvironmentsConfig
